import React, { useEffect, useState } from "react";
import CardAnalytics from "../CardAnalytics";

export default function RestaurantCards({ data }) {
  const [active, setActive] = useState([]);
  const [inactive, setInactive] = useState([]);
  const [unapproved, setUnapproved] = useState([]);
  useEffect(() => {
    setActive(data.filter((restaurant) => restaurant.status === "Active"));
    setInactive(data.filter((restaurant) => restaurant.status === "Inactive"));
    setUnapproved(data.filter((restaurant) => restaurant.status === "Unapproved"));
  }, [data]);
  return (
    <div className="row">
      <CardAnalytics title="Total" description="Total Restaurant" value={data.length} status="text-secondary" />
      <CardAnalytics title="Active" description="Active Restaurant" value={active.length} status="text-success" />
      <CardAnalytics title="Inactive" description="Inactive Restaurant" value={inactive.length} status="text-danger" />
      <CardAnalytics title="Unapproved" description="Unapproved Restaurant" value={unapproved.length} status="text-warning" />
    </div>
  );
}
